<template>
  <div class="OrderProduct">
    <div class="OrderProduct__details">
      <div class="OrderProduct__details__description">
        <small v-if="product.FORMAT && product.FORMAT.CODFORMATO"
        >{{product.FORMAT.DESCRIPCION}}
        </small>
        {{product.DESCRIPCION.toUpperCase()}}
      </div>
      <div class="OrderProduct__details__precio">
        <span class="badge badge-warning">{{productTotal}}€</span>
      </div>
    </div>
    <div class="OrderProduct__precio">
      <div class="OrderProduct__precio__delete">
        <button class="btn btn-light" v-if="editable"
                @click="deleteProduct">
          <i class="fa fa-trash mr-2" />
          <small class="text-muted">QUITAR</small>
        </button>
      </div>
      <div class="OrderProduct__precio__label">
        <small>{{productPrecio}}€</small>
        <small class="ml-2 mr-2">x</small>
        <template v-if="editable">
          <button @click="$emit('del')" class="btn btn-light"><i class="fa fa-minus" /></button>
          <strong class="OrderProduct__precio__label__uds">{{product.UDS}}</strong>
          <button @click="$emit('add')" class="btn btn-light"><i class="fa fa-plus" /></button>
        </template>
        <small v-else>{{product.UDS}}</small>
      </div>
    </div>
    <div v-if="product.EXTRAS" class="OrderProduct__extras">
      <div v-for="extra in product.EXTRAS" :key="extra.CODMODIFICADOR" class="OrderProduct__extras__extra">
        {{extra.extra.DESCRIPCION}}
        <li v-for="opcion in extra.options" :key="opcion.CODARTICULO" class="OrderProduct__extras__extra__opcion">
          <span class="OrderProduct__extras__extra__opcion__descripcion">
            {{opcion.DESCRIPCION}}
            <div :key="e.CODMODIFICADOR" v-for="e in opcion.OPTIONS" class="OrderProduct__extras__extra__opcion__descripcion__extras">
              {{e.extra.DESCRIPCION}}<br>
              <div :key="o.CODARTICULO" v-for="o in e.options" class="OrderProduct__extras__extra__opcion__descripcion__extras__opcion">
                {{o.DESCRIPCION}} 
                <small v-if="Number(o.INCPRECIO || 0) > 0">+{{Number(o.INCPRECIO || 0).toFixed(2)}}€</small>
              </div><br>
            </div>
          </span>
          <span class="OrderProduct__extras__extra__opcion__precio" v-if="showInc(opcion)">{{incPrecio(opcion)}}</span>
        </li>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    product: { type: Object },
    editable: { type: Boolean, default: false }
  },
  computed: {
    format() {
      return this.product.FORMAT || {}
    },
    productPrecio() {
      let pvp = Number(this.product.PVP)
      if (this.format && Number(this.format.PVP) > 0)
        pvp = Number(this.format.PVP)
      return pvp.toFixed(2)
    },
    productTotal() {
      let uds = Number(this.product.UDS)
      let total = Number(this.productPrecio)
      const extras = this.product.EXTRAS || []
      extras.forEach(e => {
        const options = e.options || []
        options.forEach(o => {
          total += Number(o.INCPRECIO || 0)
        })
      })
      return (uds * total).toFixed(2)
    }
  },
  methods: {
    async deleteProduct() {
      this.$emit('deleteProduct', this.product)
    },
    showInc(option) {
      const inc = Number(option.INCPRECIO)
      return inc > 0 || inc < 0
    },
    incPrecio(option) {
      let inc = Number(option.INCPRECIO || 0)
      let sim = inc > 0 ? '+' : ''
      return `${sim}${inc.toFixed(2)}€`
    },
    frmPrecio(format) {
      let inc = Number(format.PVP)
      return `${inc.toFixed(2)}€`
    }
  }
}
</script>
<style lang="scss">
.OrderProduct {
  background-color: white;
  border-radius: 0.32rem;
  padding: 0.4rem;
  display: flex;
  flex-direction: column;
  font-weight: bold;
  margin-bottom: 0.4rem;

  @media screen and (max-width: 340px) {
    font-size: 0.92rem;
  }

  &__details {
    flex: 1;
    display: flex;
    align-items: flex-end;

    .btn {
      color: #59626a;
    }

    &__description {
      flex: 1;

      small {
        display: block;
      }
    }

    &__precio {
      font-size: 1.2rem;

      @media screen and (max-width: 340px) {
        font-size: 1rem;
      }
    }
  }

  &__extras {
    border-top: 0.05rem dashed #ccc;
    color: #59626a;
    font-weight: normal;
    font-size: 0.82rem;
    width: 100%;
    margin-top: 0.5rem;
    padding-top: 0.5rem;
    padding-left: 0.4rem;

    @media screen and (max-width: 340px) {
      font-size: 0.72rem;
    }

    &__extra {
      font-weight: bold;

      &__opcion {
        display: flex;
        font-weight: normal;

        &__descripcion {
          flex: 1;
          padding: 0.2rem;
          &:before {
            content: '- ';
          }
          &__extras {
            color: #a7a7a7;
            font-size: 0.9em;
            padding-left: 0.6rem;
            font-weight: bold;
            &__opcion {
              font-weight: normal;
              &:before {
                content: '- ';
              }
            }
          }
        }
      }
    }
  }

  &__precio {
    align-items: center;
    border-top: 0.05rem dashed #ccc;
    margin-top: 0.5rem;
    display: flex;
    padding-top: 0.5rem;
    padding-left: 0.4rem;

    @media screen and (max-width: 340px) {
      margin-top: 0.4rem;
      padding: 0.2rem;
    }

    &__delete {
      flex: 1;
      @media screen and (max-width: 340px) {
        font-size: 0.82rem;
        flex: inherit;
        text-align: center;
        margin-right: 0.2rem;
        i {
          margin: 0 !important;
        }
        small {
          display: none;
        }
      }
    }

    &__label {
      color: #35383d;
      font-size: 1.2rem;
      margin-right: 0.2rem;

      @media screen and (max-width: 340px) {
        flex: 1;
        width: 100%;
        display: flex;
        align-items: center;

        small {
          flex: 1;
        }
      }

      &__uds {
        display: inline-block;
        text-align: center;
        width: 38px !important;
        @media screen and (max-width: 340px) {
          //
        }
      }

      .money-sign {
        align-items: center;
        background-color: #eaeaea;
        border-radius: 0.23rem;
        color: #474f57;
        display: inline-flex;
        font-size: 0.82rem;
        font-weight: normal;
        height: 24px;
        justify-content: center;
        margin-right: 0.4rem;
        width: 24px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Order/OrderProduct.vue